
























import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import ListDecorator from './ListDecorator.vue';
import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';
import Mixin from '../mixin';
import Message from '../class/Message';

@Component({
  components: { ListDecorator },
})
export default class MessageList extends Mixin {
  @Prop() private groupid!: string;
  @State private message!: any;
  @Mutation private setMessage!: (obj: {id: string, messages: Message[]}) => void;
  @Mutation private addMessage!: (obj: {id: string, messages: Message[]}) => void;
  @Mutation private sortMessage!: (obj: {id: string, prop: string, asc: boolean}) => void;
  private reading: boolean = false;
  private sortProp: string = '';
  private sortAsc: boolean = false;

  private mounted() {
    if (!navigator.onLine) {
      return;
    }
    if (!this.message[this.groupid] || this.message[this.groupid].length === 0) {
      this.getMessage();
    } else {
      this.readMore(true);
    }
  }

  private async del() {
    this.confirm('削除してもよろしいですか?', async () => {
      const body = Array.from(this.$el.querySelectorAll('td:first-of-type .mdl-checkbox.is-checked'))
        .map((v: any, i: any, self: any[]) => {
          const p = v.parentElement.parentElement as any;
          return { OrganizationID: this.groupid, ID: p.id };
        });
      try {
        this.block();
        await API.del('api', '/message/delete', {
          headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
          body,
        });
        this.msg('メッセージを削除しました');
        this.getMessage();
      } catch (ex) {
        this.msg(ex);
      } finally {
        this.uncheck();
        this.unblock();
      }
    });
  }

  private uncheck() {
    Array.from(this.$el.querySelectorAll('tr td:first-of-type .mdl-checkbox.is-checked'))
      .forEach((v: any, i: any, self: any[]) => {
        v.classList.remove('is-checked');
        (v.querySelector('input[type="checkbox"]') as HTMLInputElement).checked = false;
      });
  }

  private reload(p: (f: () => void) => void): void {
    p(async () => {
      await this.getMessage();
    });
  }

  private scroll(event: any) {
    if (!navigator.onLine) {
      return;
    }
    if (event.target.scrollTop >= event.target.scrollHeight - event.target.offsetHeight) {
      this.readMore(false);
    }
  }

  private async getMessage() {
    const messages = await API.post('api', '/message', {
      headers: { Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
      body: { OrganizationID: this.groupid },
    });
    this.setMessage({id: this.groupid, messages });
  }

  private async readMore(future: boolean) {
    if (this.reading) {
      return;
    }
    const btn = this.$el.querySelector('.btn_read') as HTMLInputElement;
    if (!btn) {
      return;
    }
    btn.disabled = true;
    this.reading = true;
    let oldest = this.message[this.groupid][0].Created;
    (this.message[this.groupid] as Message[]).forEach((m) => {
      if (future) {
        if (oldest < m.Created) {
          oldest = m.Created;
        }
      } else {
        if (oldest > m.Created) {
          oldest = m.Created;
        }
      }
    });
    try {
      const messages: Message[] = await API.post('api', '/message', {
        headers: { Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
        body: { OrganizationID: this.groupid, Time: oldest, Future: future },
      });
      if (future) {
        this.setMessage({id: this.groupid, messages: messages.concat(this.message[this.groupid])});
      } else {
        this.addMessage({id: this.groupid, messages });
      }
    } catch (ex) {
      this.msg(ex);
    } finally {
      btn.disabled = false;
    }
    this.reading = false;
  }

  private sort(prop: string) {
    this.sortProp = prop;
    this.sortAsc = !this.sortAsc;
    this.sortMessage({id: this.groupid, prop: this.sortProp, asc: this.sortAsc});
  }

}
